// extracted by mini-css-extract-plugin
export default {"container":"products_container__ySXJL","products":"products_products__EpMwQ","menu":"products_menu__OkP8n","list":"products_list__xdqdQ","product":"products_product__weCnK"};